import { useI18n } from "@/i18n/I18nProvider";
import { fmtNum } from "@/lib/format";

const BADGE = {
  YER_OLD: "bg-amber-50 text-amber-900 border-amber-300",
  YER_NEW: "bg-emerald-50 text-emerald-900 border-emerald-300",
  SAR: "bg-sky-50 text-sky-900 border-sky-300",
  USD: "bg-slate-50 text-slate-800 border-slate-300",
};

export const CurrencyBadge = ({ code, testId }) => {
  const { t } = useI18n();
  return <span data-testid={testId} className={`inline-block rounded-md border px-2 py-0.5 text-[11px] font-semibold ${BADGE[code]}`}>{t(`currency.${code}`)}</span>;
};

export default function PriceTag({ price, size = "md", testId = "price" }) {
  const { t } = useI18n();
  const big = size === "lg";
  return (
    <div className="space-y-1.5">
      {price.on_request ? (
        <p data-testid={testId} className={`font-display font-bold text-navy ${big ? "text-2xl" : "text-base"}`}>{t("price.onRequest")}</p>
      ) : (
        <p data-testid={testId} className={`font-bold text-navy ${big ? "text-3xl" : "text-lg"}`} dir="ltr" style={{ unicodeBidi: "isolate" }}>
          <span className="font-[Plus_Jakarta_Sans]">{fmtNum(price.amount)}</span>
          {price.rent_period && <span className="text-sm font-medium text-ink-muted"> / {t(`rentPeriod.${price.rent_period}`)}</span>}
        </p>
      )}
      <div className="flex flex-wrap items-center gap-1.5">
        <CurrencyBadge code={price.currency} testId={`${testId}-currency`} />
        {price.negotiable && <span className="bay-chip">{t("price.negotiable")}</span>}
      </div>
    </div>
  );
}
